/* tslint:disable */
/* eslint-disable */
/**
 * Query Runner
 * Provides an API for running a query against records and returning detailed per query node match information.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NoticeSearchAggregationQueryAggregationsInner } from './NoticeSearchAggregationQueryAggregationsInner';
import {
    NoticeSearchAggregationQueryAggregationsInnerFromJSON,
    NoticeSearchAggregationQueryAggregationsInnerFromJSONTyped,
    NoticeSearchAggregationQueryAggregationsInnerToJSON,
} from './NoticeSearchAggregationQueryAggregationsInner';
import type { NoticeSearchQueryFilters } from './NoticeSearchQueryFilters';
import {
    NoticeSearchQueryFiltersFromJSON,
    NoticeSearchQueryFiltersFromJSONTyped,
    NoticeSearchQueryFiltersToJSON,
} from './NoticeSearchQueryFilters';

/**
 * 
 * @export
 * @interface NoticeSearchAggregationQuery
 */
export interface NoticeSearchAggregationQuery {
    /**
     * Query identifier, used for logging & debugging
     * @type {string}
     * @memberof NoticeSearchAggregationQuery
     */
    id: string;
    /**
     * The page number to return, starting from 0
     * @type {number}
     * @memberof NoticeSearchAggregationQuery
     */
    page: number;
    /**
     * The number of results to return per page
     * @type {number}
     * @memberof NoticeSearchAggregationQuery
     */
    size: number;
    /**
     * The field to sort the results by
     * @type {string}
     * @memberof NoticeSearchAggregationQuery
     */
    sortBy: string;
    /**
     * The order to sort the results by
     * @type {string}
     * @memberof NoticeSearchAggregationQuery
     */
    sortOrder: NoticeSearchAggregationQuerySortOrderEnum;
    /**
     * The language codes to be used for the search. 
     *         Internally we currently support en, de, es, fr, and nl. 
     *         Other languages will fall back to the default analyzer.
     * @type {Array<string>}
     * @memberof NoticeSearchAggregationQuery
     */
    languages: Array<string>;
    /**
     * 
     * @type {NoticeSearchQueryFilters}
     * @memberof NoticeSearchAggregationQuery
     */
    filters?: NoticeSearchQueryFilters;
    /**
     * The field to group the results by
     * @type {string}
     * @memberof NoticeSearchAggregationQuery
     */
    groupingField: NoticeSearchAggregationQueryGroupingFieldEnum;
    /**
     * Describes a specific aggregation operation performed on one field.
     *   The aggregation will be identified in the result by 'name'.
     *   The set of allowed field/operation combinations will depend on the data type used.
     *   All data types should allow 'COUNT' operation on 'id' field, which will
     *   return the count of objects in each group (similar to SELECT COUNT(*) FROM ... GROUP BY ...).
     * @type {Array<NoticeSearchAggregationQueryAggregationsInner>}
     * @memberof NoticeSearchAggregationQuery
     */
    aggregations: Array<NoticeSearchAggregationQueryAggregationsInner>;
}


/**
 * @export
 */
export const NoticeSearchAggregationQuerySortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type NoticeSearchAggregationQuerySortOrderEnum = typeof NoticeSearchAggregationQuerySortOrderEnum[keyof typeof NoticeSearchAggregationQuerySortOrderEnum];

/**
 * @export
 */
export const NoticeSearchAggregationQueryGroupingFieldEnum = {
    BuyerId: 'buyer.id',
    SupplierId: 'supplier.id',
    CountryCode: 'country_code',
    CpvCode: 'cpv_code',
    BuyerPublicSectorOrgType: 'buyer.public_sector_org_type',
    BuyerRegion: 'buyer.region',
    SupplierIsSme: 'supplier.is_sme'
} as const;
export type NoticeSearchAggregationQueryGroupingFieldEnum = typeof NoticeSearchAggregationQueryGroupingFieldEnum[keyof typeof NoticeSearchAggregationQueryGroupingFieldEnum];


/**
 * Check if a given object implements the NoticeSearchAggregationQuery interface.
 */
export function instanceOfNoticeSearchAggregationQuery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "sortBy" in value;
    isInstance = isInstance && "sortOrder" in value;
    isInstance = isInstance && "languages" in value;
    isInstance = isInstance && "groupingField" in value;
    isInstance = isInstance && "aggregations" in value;

    return isInstance;
}

export function NoticeSearchAggregationQueryFromJSON(json: any): NoticeSearchAggregationQuery {
    return NoticeSearchAggregationQueryFromJSONTyped(json, false);
}

export function NoticeSearchAggregationQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoticeSearchAggregationQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'page': json['page'],
        'size': json['size'],
        'sortBy': json['sortBy'],
        'sortOrder': json['sortOrder'],
        'languages': json['languages'],
        'filters': !exists(json, 'filters') ? undefined : NoticeSearchQueryFiltersFromJSON(json['filters']),
        'groupingField': json['groupingField'],
        'aggregations': ((json['aggregations'] as Array<any>).map(NoticeSearchAggregationQueryAggregationsInnerFromJSON)),
    };
}

export function NoticeSearchAggregationQueryToJSON(value?: NoticeSearchAggregationQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'page': value.page,
        'size': value.size,
        'sortBy': value.sortBy,
        'sortOrder': value.sortOrder,
        'languages': value.languages,
        'filters': NoticeSearchQueryFiltersToJSON(value.filters),
        'groupingField': value.groupingField,
        'aggregations': ((value.aggregations as Array<any>).map(NoticeSearchAggregationQueryAggregationsInnerToJSON)),
    };
}

